import "../base.js"; // VITE_MIGRATION: ensures SP_EVENTS is defined before this module runs
import "../form.js";

jQuery(function () {
  window.nestedInsertCounter = 0;

  var CLASSNAMES = {
    HIDDEN: "--hidden",
    EMPTY: "--empty",
    FOCUS: "--focus",
  };

  var DATA_ATTRS = {
    RECORDS_SIZE: "records-size",
    FIELDS_COUNT: "fieldsCount",
  };

  var selectors = {
    trigger: "[data-behaviour~=nested-insert]",
    triggerRemove: "[data-behaviour~=nested-remove]",
    container: "[data-behaviour~=nested-insert-container]",
    assocContainer: "[data-behaviour~=nested-insert-container].nested-insert-with-associations",
    target: "[data-behaviour~=nested-insert-target]",
    template: "[data-behaviour~=nested-insert-template]",
    domId: "[data-behaviour~=nested-insert-dom-id]",
    childIndexInput: "[name=nested_child_index]",
    prepend: "nested-insert-prepend",
    dropdownWithInput: ".dropdown-with-input",
    emptyMessage: ".empty-message-view",
    nestedForm: ".nested-form",
  };

  function setupNestedInsertContainer(container) {
    var $container = jQuery(container);
    var fieldsCount = jQuery(selectors.nestedForm, container).data(DATA_ATTRS.RECORDS_SIZE);
    $container.data(DATA_ATTRS.FIELDS_COUNT, fieldsCount);
    $container.on("nested:change:count", handleChangeFieldsCount);
    handleToggleContainerModifierClass($container, fieldsCount < 1);
  }

  function handleToggleContainerModifierClass($container, state) {
    $container.toggleClass(CLASSNAMES.EMPTY, state);
  }

  function handleChangeFieldsCount(event, data) {
    const $container = jQuery(this);
    const count = $container.data(DATA_ATTRS.FIELDS_COUNT);
    const nextCount = count + data;
    jQuery(this).data(DATA_ATTRS.FIELDS_COUNT, nextCount);
    $container.toggleClass(CLASSNAMES.EMPTY, nextCount < 1);
    handleToggleContainerModifierClass($container, nextCount < 1);
  }

  function hideEmptyMessageView($container) {
    $container.find(selectors.emptyMessage).addClass(CLASSNAMES.HIDDEN);
  }

  // Helper Method to uniq form attributes.
  function uniqFormAttributes(formHtml) {
    var childIndex = jQuery(formHtml).filter(selectors.childIndexInput).val();
    if (childIndex) {
      formHtml = formHtml.replace(new RegExp(childIndex, "g"), "new_" + nestedInsertCounter);
    }

    var form = jQuery(formHtml);
    jQuery(form)
      .find(selectors.domId)
      .addBack(selectors.domId)
      .each(function (i, domIdContainer) {
        updateAttribute(jQuery(domIdContainer), "id");
        updateAttribute(jQuery(domIdContainer).find("[name=dom_id]"), "value");
      });

    jQuery(form)
      .find(".tab-selectors [data-behaviour=tabstate]")
      .each(function (i, tabInput) {
        updateAttribute(tabInput, "aria-controls");
        updateAttribute(tabInput, "id");
        updateAttribute(tabInput, "name");
      });

    jQuery(form)
      .find(".tab-selectors label")
      .each(function (i, tabLabel) {
        updateAttribute(tabLabel, "for");
      });

    jQuery(form)
      .find(".tab-panel")
      .each(function (i, tab) {
        updateAttribute(tab, "id");
      });

    return form;
  }

  function updateAttribute(element, attr) {
    var old_attr = jQuery(element).attr(attr);
    jQuery(element).attr(attr, old_attr + "_" + nestedInsertCounter);
  }

  window.NestedInsert = window.NestedInsert || {};

  // Builds the next row from a container's template, advancing the shared
  // child-index counter.
  window.NestedInsert.nextForm = function (container) {
    nestedInsertCounter++;
    return uniqFormAttributes(jQuery(container).children(selectors.template).html());
  };

  // Initial setup containers

  Array.from(document.querySelectorAll(selectors.assocContainer)).forEach(setupNestedInsertContainer);

  // LISTENERS

  jQuery(document).on("nested-inserts:setup", function (event, element) {
    setupNestedInsertContainer(element);
  });

  jQuery(document).on("click", selectors.trigger, function (event, data) {
    var $this = jQuery(this);
    var $container = jQuery(this).closest(selectors.container);
    var target = $container.children(selectors.target);
    var newForm = window.NestedInsert.nextForm($container);

    newForm.hide(); // preparing for slide down animation

    if ($this.data(selectors.prepend)) {
      target.prepend(newForm);
    } else {
      target.append(newForm);
    }

    newForm.slideDown(SP_EVENTS.SLIDE_DOWN.DEFAULT_DURATION);
    Form.decorate(target);

    $container.trigger("nested:change:count", 1);
    hideEmptyMessageView($container);
  });

  // Listen to remove nested item
  jQuery(document).on(SP_EVENTS.SLIDE_UP.TYPE, function (event, element) {
    jQuery(element).parent().trigger("nested:change:count", -1);
  });
});
